import React from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { Button, AuthComponent, Card, AppCTA, DynamicContent } from '../components';
import { routes, accountConstants } from '../constants';
import { AuthDelegate } from '../utils';
import { RouteActions } from '../actions';

const { statuses, loginStates } = accountConstants;

class SubmittedPage extends AuthComponent {

    componentWillMount() {
        super.componentWillMount();
        this.props.dispatch(RouteActions.setAppState(routes.SUBMITTED));
    }

    userIsAuthorized(user) {
        return user.loginState === loginStates.LOGGED_IN && user.approvalStatus === statuses.SUBMITTED;
    }

    componentWillRejectUser(user) {
        if(!AuthDelegate.requireLogin(user)) {
            return;
        }

        switch (user.approvalStatus) {
            case statuses.APPROVED:
                browserHistory.push(routes.HOME);
                break;
            case statuses.UNSUBMITTED:
                browserHistory.push(routes.VERIFY);
                break;
            default:
                browserHistory.push(routes.LOGIN);
                break;
        }
    }

    authRender () {
        return (
            <div className="container component-login-widget" id="verify-page">
                <div className="row center-cols">
                    <div className="col-sm-5">
                        <Card className="center">
                            <h3 className="card-title">Account Being Verified</h3>
                            <div>
                                <DynamicContent>
                                    <p>
                                        Please wait until we verify your account. This may take up to 24 hours. In the meantime, feel free to learn more about our sample taking guidelines or our recommended flushing procedure.
                                    </p>
                                    <p>
                                        <Button to={routes.SAMPLING_GUIDELINES} className="primary">Sample Taking Guidelines</Button>
                                    </p>
                                    <p>
                                        <Button to={routes.FLUSHING_CONVERTING_PROCEDURE} className="primary">Recommended Flushing Procedure</Button>
                                    </p>
                                </DynamicContent>
                            </div>
                        </Card>
                        <AppCTA></AppCTA>
                    </div>
                </div>
            </div>
        )
    }
}

function select(state) {
    return {
        user: state.activeUser
    }
}

export default connect(select)(SubmittedPage);



// WEBPACK FOOTER //
// ./web-app/containers/submitted.jsx